import { render } from "./QC2.vue?vue&type=template&id=c178a8f6"
import script from "./QC2.vue?vue&type=script&lang=js"
export * from "./QC2.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QCCharts/microgen/QC2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c178a8f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c178a8f6', __exports__)) {
    console.log('reload')
    api.reload('c178a8f6', __exports__)
  }
  
  module.hot.accept("./QC2.vue?vue&type=template&id=c178a8f6", () => {
    console.log('re-render')
    api.rerender('c178a8f6', render)
  })

}


export default __exports__